var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerT(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 64,
    viewBox: "0 0 27 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8398 0.469727H14.3398V4.64639H12.8398V0.469727ZM12.8398 25.5297H14.3398V29.7064H12.8398V25.5297ZM12.8398 33.8831H14.3398V38.0597H12.8398V33.8831ZM14.3398 42.2364H12.8398V46.4131H14.3398V42.2364ZM12.8398 50.5897H14.3398V54.7664H12.8398V50.5897ZM14.3398 58.9431H12.8398V63.1197H14.3398V58.9431ZM14.3398 17.1764H12.8398V21.3531H14.3398V17.1764ZM12.8398 8.82306H14.3398V12.9997H12.8398V8.82306ZM2.50977 32.3273H0.509766V33.8935H2.50977V32.3273ZM6.93945 32.3273H11.3695V33.8935H6.93945V32.3273ZM20.2396 32.3273H15.8096V33.8935H20.2396V32.3273ZM24.6797 32.3273H26.6797V33.8935H24.6797V32.3273Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerT);
export default __webpack_public_path__ + "static/media/LOWER_T.1df7d9f33bef2e681c0398f0f9c5430d.svg";
export { ForwardRef as ReactComponent };